// extracted by mini-css-extract-plugin
export default {"title":"ChangeLog_title__Nlyie"};